<template>
  <ais-pagination
    :padding="2"
    @page-change="scrollUpToSearchResults"
  >
    <template
      #first="{ createURL, isFirstPage, refine }"
    >
      <a
        v-if="!isFirstPage"
        class="ais-Pagination-link"
        :aria-label="$t('First')"
        :href="createURL(0)"
        @click.prevent="refine(0)"
      >{{ $t('First') }}</a>
      <span
        v-else
        class="ais-Pagination-link"
        :aria-label="$t('First')"
      >{{ $t('First') }}</span>
    </template>
    <template #last="{ isLastPage, createURL, refine }">
      <a
        v-if="!isLastPage"
        class="ais-Pagination-link"
        aria-label="Last"
        :href="createURL()"
        @click.prevent="refine()"
      >{{ $t('Last') }}</a>
      <span
        v-else
        class="ais-Pagination-link"
        aria-label="Last"
      >{{ $t('Last') }}</span>
    </template>
    <template #previous="{ createURL, isFirstPage, refine }">
      <a
        v-if="!isFirstPage"
        class="ais-Pagination-link iconify svg--chevron-left"
        :aria-label="$t('Previous')"
        :href="createURL()"
        @click.prevent="refine()"
      />
      <button
        v-else
        class="ais-Pagination-link iconify svg--chevron-left"
        :aria-label="$t('Previous')"
      />
    </template>
    <template #next="{ createURL, isLastPage, refine }">
      <a
        v-if="!isLastPage"
        class="ais-Pagination-link iconify svg--chevron-right"
        :aria-label="$t('Next')"
        :href="createURL()"
        data-testid="paginationNextPage"
        @click.prevent="refine()"
      />
      <button
        v-else
        class="ais-Pagination-link iconify svg--chevron-right"
        :aria-label="$t('Next')"
      />
    </template>
  </ais-pagination>
</template>

<script lang="ts">

import { AisPagination } from 'vue-instantsearch/vue3/es';
import { scrollToSection } from '~~/helpers/scroll/scrollToSection';

export default defineComponent({
  name: 'PaginationWrapper',
  components: {
    AisPagination,
  },
  setup() {

    const scrollUpToSearchResults = () => {

      scrollToSection('#layout');
    
    };

    return {
      scrollUpToSearchResults,
    };
  
  },
});

</script>
